import { SchedulingQueryParams } from '../../Router/constants';
import { ProjectUnscheduledStopsDeletedDtoModelType } from '../../models/ProjectUnscheduledStopsDeletedDtoModel';
import getAppRoot from '../../utils/getAppRoot';
import { getCustomerOrderReturn } from '../../../../components/customerProfiles/customerOrderNavigation';

export default ({ store, deletedVisits }: ProjectUnscheduledStopsDeletedDtoModelType) => {
  const rootStore = getAppRoot(store);

  return () => {
    const selectedOrder = rootStore.router.queryParams.get(SchedulingQueryParams.ORDER);
    deletedVisits?.forEach(deletedVisit => {
      const visitUuid = rootStore.model.visitDtos.get(deletedVisit.id)?.uuid;
      rootStore.model.customerOrderDtos.get(deletedVisit.id)?.markDeleted();
      rootStore.model.visitDtos.delete(deletedVisit.id);

      if (visitUuid && selectedOrder === visitUuid) {
        const destination = getCustomerOrderReturn(rootStore.router.location?.state);
        if (destination) rootStore.router.replace(destination);
        else rootStore.router.replaceQueryParams({ [SchedulingQueryParams.ORDER]: null }, true);
      }
    });
  };
};
